export default __webpack_public_path__ + "static/media/Close.3e1c983d.svg";